import type { ModalFC } from '@/components/modals/modalsManager';
import { Dialog } from '@/components/ui/dialog';

import { IntegrationManagementView } from './integration-management-settings';

import type { ProviderKey } from '@littlebird/integrations';

export const IntegrationManagementModal: ModalFC<{
  providerKey?: ProviderKey;
}> = ({ open, onOpenChange, providerKey }) => (
  <Dialog.Root open={open} onOpenChange={onOpenChange}>
    <Dialog.Content
      className="h-[85vh] max-w-5xl overflow-hidden bg-background-subtle p-0"
      onOpenAutoFocus={(event) => event.preventDefault()}
    >
      <Dialog.Title className="sr-only">Integrations</Dialog.Title>
      <IntegrationManagementView providerKey={providerKey} />
    </Dialog.Content>
  </Dialog.Root>
);
